import type { TemplateVariableGroup } from "../../components/TemplateBuilder/TemplateBuilder";

/**
 * Mustache merge-fields available to invoice/receipt templates. These mirror
 * exactly the variable map produced by nodefork's invoice renderer
 * (nodefork/src/utils/invoice-template-render.util.ts → buildVars). Keep the two
 * in sync: a field here that the renderer doesn't emit will simply render blank,
 * and a renderer field missing here just won't be draggable.
 *
 * Dragging a field onto the canvas inserts its Mustache tag as text; nodefork
 * runs Mustache.render over the saved body at print time.
 */
export const INVOICE_VARIABLE_GROUPS: TemplateVariableGroup[] = [
  {
    label: "Recipient",
    items: [
      { label: "Invoice name", tag: "{{invoiceName}}" },
      { label: "Student name", tag: "{{studentName}}" },
      // triple-mustache: address is pre-escaped HTML with <br/> line breaks
      { label: "Address (multi-line)", tag: "{{{invoiceAddressDisplay}}}" },
      { label: "Application label", tag: "{{applicationLabel}}" },
      { label: "Application value", tag: "{{applicationValue}}" },
    ],
  },
  {
    label: "Invoice",
    items: [
      { label: "Invoice number", tag: "{{invoiceNumber}}" },
      { label: "Invoice date", tag: "{{invoiceDate}}" },
      { label: "Due date", tag: "{{invoiceDueDate}}" },
      { label: "Currency", tag: "{{currency}}" },
      { label: "Remarks", tag: "{{remarks}}" },
    ],
  },
  {
    label: "Programme",
    items: [
      { label: "Programme name", tag: "{{programName}}" },
      { label: "Course name", tag: "{{courseName}}" },
      { label: "Course code", tag: "{{courseCode}}" },
      { label: "Instalment name", tag: "{{installmentName}}" },
      { label: "Fee heads", tag: "{{headNames}}" },
      { label: "Module start", tag: "{{moduleStartDate}}" },
      { label: "Module end", tag: "{{moduleEndDate}}" },
    ],
  },
  {
    label: "Amounts",
    items: [
      { label: "Plan amount", tag: "{{planAmount}}" },
      { label: "Net amount", tag: "{{netPlanAmount}}" },
      { label: "Discount", tag: "{{discount}}" },
      { label: "Tax amount", tag: "{{taxAmount}}" },
      { label: "Tax %", tag: "{{taxPercentage}}" },
      { label: "Total payable", tag: "{{toBePaid}}" },
    ],
  },
  {
    label: "Branding",
    items: [
      {
        label: "Institute logo",
        tag: "{{logoUrl}}",
        content: `<img src="{{logoUrl}}" alt="Logo" style="max-height:64px;max-width:220px;object-fit:contain"/>`,
      },
    ],
  },
  {
    label: "Sections (show/hide)",
    items: [
      {
        label: "Application row",
        tag: "{{#showApplicationRow}}",
        content:
          `<div data-gjs-type="text">{{#showApplicationRow}}{{applicationLabel}}: {{applicationValue}}{{/showApplicationRow}}</div>`,
      },
      {
        label: "Enquiry-only block",
        tag: "{{#isEnquiry}}",
        content:
          `<div data-gjs-type="text">{{#isEnquiry}}Enquiry-stage invoice{{/isEnquiry}}</div>`,
      },
    ],
  },
];
